import React from "react";
import { SalesManagement } from "./KanbanBoard";

export interface Task {
    id: string;
    title: string;
    status: "todo" | "inProgress" | "done" | "lost";
    priority: "low" | "medium" | "high";
    category: "Kurzzeitpflege" | "Vollstationäre Pflege" | "Pflegedienst";
    dueDate?: string;
    description?: string;
    assignedTo?: string;
}

const TaskManagementView: React.FC = () => {

    return (
            <SalesManagement />

    );
};

export default TaskManagementView;
